<template>
  <div>
    <div
      class="toggler br-12"
      :class="{ active: active || status }"
      @click="toggle"
    >
      <div class="circle" :class="{ active: active || status }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["status"],
  data() {
    return {
      active: false,
      toggled: true
    };
  },
  methods: {
    toggle() {
      if (!this.status) {
        this.active = !this.active;
      }
    }
  }
};
</script>

<style scoped>
.toggler {
  width: 35px;
  height: 18px;
  background: #2a3946;
  position: relative;
  transition: 0.4s;
  cursor: pointer;
}
.toggler.active {
  background: var(--tbc-blue);
  transition: 0.4s;
}
.circle {
  transform: translate(2px, 2px);
  width: 14px;
  height: 14px;
  border-radius: 50%;
  transition: 0.4s;
  background: white;
}
.circle.active {
  transform: translate(18px, 2px);
  transition: 0.4s;
  background: #1d2934;
}
</style>
